/**
 * O endereço de uma tela do caso que saiu leva à que a substitui, no mesmo caso (E123.F3, E171.F3).
 * E201.F1 (GUS-47, ADR-0144): com a query e a âncora, para o link antigo com hash cair na área certa
 * da mesa única. Saiu do `router.tsx`, que passou do teto de linhas.
 */
import { Navigate, useLocation, useParams } from 'react-router-dom';

export function ParaATelaDoCaso({ tela }: { tela: string }): JSX.Element {
  const { id = '' } = useParams<{ id: string }>();
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: `/casos/${id}/${tela}`, search, hash }} replace />;
}
